import React, { useState, useEffect } from 'react';
import UnpairedProductForceCreateForm from './UnpairedProductForceCreateForm';
import * as Yup from "yup";
import { Dialog, DialogContent, DialogContentText, withStyles, DialogTitle } from '@material-ui/core';
import { snackActions } from '../../sc-utilities/SnackBar';
import * as actions from './store/unpairedProductActions';
import * as pcProductActions from '../../sc-product/PCProduct/store/pcProductActions';
import { hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import { CancelToken } from 'axios';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    },
    "[class*='MuiTableCell-root MuiTableCell-body']": {
        height: "40px",
        padding: '2px',
        fontSize: '0.7rem'
    },
});

const UnpairedProductForceCreate = props => {
    let { onFetchCollies, onBulkForceCreate, creating, forceCreateModalState, setForceCreateModalState, onFetchOrders, permissions, activeCustomerID, translations, onForceCreate } = props;
    const [createData, setCreateData] = useState({ orders: [], collies: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let orderData = await onFetchOrders({ ActiveCustomerID: activeCustomerID });
            if (orderData instanceof Array && orderData.length < 1) {
                snackActions.snackBarComponent("No  orders, cannot select  order.", "info");
            }
            let collies = await onFetchCollies({ Deleted: false, ActiveCustomerID: activeCustomerID });
            if (collies instanceof Array && collies.length < 1) {
                snackActions.snackBarComponent("No collies found, cannot select colli.", "info");
            }
            setCreateData({ orders: orderData, collies: collies, loadingData: false });
        };
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
    }, [onFetchOrders, onFetchCollies, activeCustomerID]);

    const handleSubmit = async formData => {
        let result = null;
        if (forceCreateModalState.forBulk) {
            result = await onBulkForceCreate({ ...formData, ActiveCustomerID: activeCustomerID, ProductExternalInfoIDs: forceCreateModalState.productExternalInfoIDs });
        } else {
            result = await onForceCreate({ ...formData, ActiveCustomerID: activeCustomerID, ProductExternalInfoID: forceCreateModalState.productExternalInfoID, });
        }
        if (result) {
            setForceCreateModalState({ open: false, productExternalInfoID: null, productExternalInfoIDs: [], forBulk: false });
        }
    };

    let initialValues = {};

    let formSettings = {
        Validation: {
            OrderID: Yup.string().required("Required"),
            ColliID: Yup.string().required("Required")
        },
        FormTitle: '',
        ButtonSubmit: hasPermission(permissions, "unpaired_product_force_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Dialog
            open={forceCreateModalState.open}
            disableBackdropClick={false}
            disableEscapeKeyDown={true}
            fullWidth={true}
            onClose={() => setForceCreateModalState({ ...forceCreateModalState, open: false })}
        >
            {forceCreateModalState.forBulk ? <DialogTitle>{'Bulk force create product'}</DialogTitle> :
                <DialogTitle>{'Force create product'}</DialogTitle>}
            <DialogContent>
                <DialogContentText>
                    {translations['carefully_doing_operation'] || 'Be careful when doing this operation.'}<br />
                    {translations['sure_want_force'] || `Are you sure you want to force create`} {translations['this'] || 'this'} {translations['product'] || 'product'}?
                </DialogContentText>
                <UnpairedProductForceCreateForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    collies={createData.collies}
                    orderData={createData.orders}
                    translations={translations}
                    loading={creating}
                />
            </DialogContent>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        creating: state.product.unpairedProducts.creating
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onForceCreate: params => dispatch(actions.forceCreate(params)),
        onBulkForceCreate: params => dispatch(actions.bulkForceCreate(params)),
        onFetchOrders: (data) => dispatch(pcProductActions.fetchOrders(data)),
        onFetchCollies: (data) => dispatch(pcProductActions.fetchCollies(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(UnpairedProductForceCreate));